import React from "react"
import { CustomIconButton, PrimaryButton, TertiaryButton } from "shared/buttons"
import { useModal } from "hooks"
import { ADMIN_USERS_EXPORT_PATH, redirectTo } from "utils/routeHelpers"
import Modal, { ModalHeader } from "shared/Modal"

const ExportUsersModal = () => {
  const { modalIsOpen, openModal, closeModal } = useModal()

  const downloadUsers = () => {
    redirectTo(ADMIN_USERS_EXPORT_PATH)
    closeModal()
  }

  return (
    <>
      <CustomIconButton
        className="tertiary-button"
        icon="export"
        text="Export"
        onClick={openModal}
      />

      <Modal
        isOpen={modalIsOpen}
        aria={{ label: "export users" }}
      >
        <ModalHeader closeModal={closeModal} heading="Export Users" />
        <div className="w-3/4 mx-auto">
          <p className="text-sm text-dark text-center">
            This will download a CSV file of every active user in your organization,
            including each user&apos;s first name, last name, email address, and role.
          </p>
          <div className="flex justify-center mt-8 mb-10">
            <TertiaryButton
              text="Cancel"
              onClick={closeModal}
              className="border border-light-300 mr-2"
            />
            <PrimaryButton
              text="Download CSV"
              onClick={downloadUsers}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ExportUsersModal
